import { User } from "@super-real/types";

export function toTotalCredits(user?: User) {
  const freeCredits = user?.credits || 0;
  const paidCredits = user?.paidCredits || 0;

  return freeCredits + paidCredits;
}
